import { apiClient } from '@api/apiClient'
import { ConfigProviderState } from '@components/utils/config-provider'
import { useMutation } from '@tanstack/react-query'
import { useSnackbar } from 'notistack'

export const usePostConfig = () => {
  const { enqueueSnackbar } = useSnackbar()

  return useMutation({
    mutationFn: ({ code, ...rest }: ConfigProviderState['config'] & { code: string }) =>
      apiClient.post('/config', { code, configuration: rest }),
    onSuccess: () => {
      enqueueSnackbar('Config created', { variant: 'success' })
    },
    onError: () => {
      enqueueSnackbar('Config creation failed', { variant: 'error' })
    },
  })
}
